"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Hook for returning locale from language configuration
 */
var React = require("react");
var types_1 = require("../configuration/types");
var supportedLocales_1 = require("loom-i18n/dist/utils/supportedLocales");
function useLocale() {
    var language = React.useContext(types_1.OuiConfigurationContext).language;
    var locale = supportedLocales_1.findSupportedLocale(language);
    return locale !== undefined
        ? locale.localeTag
        : types_1.DefaultConfigurationValues.language;
}
exports.default = useLocale;
//# sourceMappingURL=useLocale.js.map